import { gql } from "@apollo/client";

import { TRADE_INFO } from "../fragments";

export const TRADE = gql`
  mutation trade($input: TradeInput!) {
    trade(input: $input) {
      ...tradeInfo
    }
  }
  ${TRADE_INFO}
`;
